import axiosApi from "."
import Qs from "qs";
import store from "../store/index"
let chainIndex = {
    //所有进线
    AllInLine: (projectId) => {
        return axiosApi({
            method: "post",
            // url: "http://192.168.1.14:8011/loop/master",
            // url: "http://localhost:8011/loop/master",
            url: "http://192.168.33.182:8444/loop/master",
            params: {
                projectId
            },
        })
    },
    //所有回路
    analogInterface: () => {
        // return axiosApi("get", "/loop/devices")({
        //     devices:config.areaId.split(',')
        // })
        return axiosApi({
            method: "get",
            // url: "http://192.168.1.14:8011/loop/all",
            // url: "http://localhost:8011/loop/all",
            // url: "http://192.168.33.182:8444/loop/all",
            url: "http://192.168.33.182:8444/loop/devices",
            params: {
                devices:config.devices
            },
        })
    },
    //三天事件
    eventThreeDay: (projectId) => {
        return axiosApi({
            method: "get",
            // url: "http://192.168.1.14:8011/alarm/details/threeDay",
            // url: "http://localhost:8011/alarm/details/threeDay",
            url: "http://192.168.33.182:8444/alarm/details/threeDay",
            params: {
                projectId
            },
        })
    },
    totayTg: (aid, alarmEventType, alarmTypeStatus, code, endTime, node, projectId, startTime, status) => {
        return axiosApi({
            method: "get",
            // url: "http://192.168.1.14:8011/alarm/add",
            // url: "http://localhost:8011/alarm/add",
            //田撒
            url: "http://192.168.33.182:8444/alarm/add",

            params: {
                aid,
                alarmEventType,
                alarmTypeStatus,
                code,
                endTime,
                node,
                projectId,
                startTime,
                status
            },
        })
    },

    echartsB: (deviceLoopId, end, node, start, group) => {
        return axiosApi({
            method: "get",
            // url: "http://192.168.1.14:8011/diagram/loop/nodes",

            // url: "http://localhost:8011/diagram/loop/nodes",
            url: "http://192.168.33.182:8444/diagram/loop/nodes",
            params: {
                deviceLoopId,
                end,
                node,
                start,
                group,
            }
        })
    },
    loopCtrl: (loopId,status,type) => {
        return axiosApi({
            method: "get",
            // url: "http://192.168.1.14:8011/diagram/loop/nodes",

            // url: "http://localhost:8011/diagram/loop/nodes",
            url: "http://192.168.33.182:8444/loop/ctrl",
            params: {
                loopId,
                status,
                type
            }
        })
    },

}


export default chainIndex